import { gate } from 'hub-http/gates';
export const REPORT_OPTIONS_CRB_BASED_GATE = gate('ReportCreation:ReportOptionsCRBBased');